module.exports = __webpack_public_path__ + "static/TRC-b0f0c2ca882c8fba9eff5560939c3053.png";